import React, {FC} from 'react';
import {AvatarItem, AvatarStack} from './Avatar';
import {ProgressRing} from './Progress';
import {Button, IconButton, Paper} from './Primitives';
import {cx} from './cx';

interface PledgeControlProps {
  amount: number;
  currency?: string;
  pledged: number;
  goal: number;
  contributors?: AvatarItem[];
  presets?: number[];
  onAmountChange: (amount: number) => void;
  onSubmit: () => void;
  className?: string;
}

export const PledgeControl: FC<PledgeControlProps> = ({
  amount,
  currency = '€',
  pledged,
  goal,
  contributors = [],
  presets = [10, 25, 50, 100],
  onAmountChange,
  onSubmit,
  className,
}) => (
  <Paper className={cx('sui-pledge', className)} variant="raised">
    <div className="sui-pledge__summary">
      <ProgressRing
        label={`${currency}${pledged} of ${currency}${goal}`}
        max={goal}
        size={120}
        value={pledged}
      />
      <div>
        <p>Friends are making it happen</p>
        <AvatarStack avatars={contributors} max={5} size="sm" />
      </div>
    </div>
    <div className="sui-pledge__amount">
      <IconButton
        icon="minus"
        label="Decrease pledge"
        onClick={() => onAmountChange(Math.max(0, amount - 5))}
        size="sm"
      />
      <strong>
        {currency}
        {amount}
      </strong>
      <IconButton
        icon="plus"
        label="Increase pledge"
        onClick={() => onAmountChange(amount + 5)}
        size="sm"
      />
    </div>
    <div aria-label="Pledge presets" className="sui-pledge__presets">
      {presets.map(preset => (
        <button
          className={cx(amount === preset && 'is-selected')}
          key={preset}
          onClick={() => onAmountChange(preset)}
          type="button"
        >
          {currency}
          {preset}
        </button>
      ))}
    </div>
    <Button fullWidth iconStart="heart" onClick={onSubmit} size="lg">
      Pledge together
    </Button>
  </Paper>
);
